import { GlobalService } from 'src/app/_services/global.service';
import { TeamCreditsService } from './../../_services/team-credits.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from './../../_services/local-storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TransactionService } from 'src/app/_services/transaction.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-subscription-usage',
  templateUrl: './subscription-usage.component.html',
  styleUrls: ['./subscription-usage.component.scss']
})
export class SubscriptionUsageComponent implements OnInit {
  history: boolean = false
  subscriptiondetails: any;
  start: number = 0
  transactionhistory: any[] = []
  @ViewChild('invitemember') invitemember: TemplateRef<any>;
  @ViewChild('removeteam') removeteam: TemplateRef<any>;
  @ViewChild('leaveteam') leaveteam: TemplateRef<any>;
  @ViewChild('resendlink') resendlink: TemplateRef<any>;
  @ViewChild('requestCredit') requestCredit: TemplateRef<any>;
  @ViewChild('reservecredits') reservecredits: TemplateRef<any>;
  @ViewChild('cancelSubscription') cancelSubscription: TemplateRef<any>;
  inviteemails: any[] = [];
  emailError: boolean;
  invitelink: any;
  credits: any;
  inputemails: string;
  teamlist: any[] = []
  emailLengthError: boolean;
  selected: boolean;
  isBulkSelect: boolean;
  selectedteams: any[] = [];
  successMessage: string;
  errorMessage: string;
  removedmemberArray: any[] = [];
  resendteamArray: any[] = [];
  userisadmin: boolean = false;
  end: any;
  total: any;
  tstart: number = 0
  noAdminCredits: boolean;
  adminDetails: any = {};
  admincredits: any;
  admincreditsError: string;
  isteamMember: boolean;
  isuseronpaidplan: boolean = false;
  isteammember: boolean = true
  teamAdminDetails: any;
  showteamtab: boolean = false;
  duplicateEmail: boolean;
  adminEmailidUsed: boolean;
  unlimitedbasiccontactcredits: any;
  adminbasiccredits: any;
  basiccredits: any;
  stripesubscriptionid: any;

  constructor(private router: Router, private transactionservice: TransactionService, private _localstorageservice: LocalStorageService, private modalService: NgbModal,
    private teamservice: TeamCreditsService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.stripesubscriptionid = this._localstorageservice.getItem('stripesubscriptionid')
    if (this.router.url.includes('history')) {
      this.history = true
    }

    if (this._localstorageservice.getItem('role') == 'team admin') {
      this.userisadmin = true
    }

    this.transactionservice.fetchpaymenttransactionhistory(this._localstorageservice.getItem('usernumber'), this.start).subscribe((res: any) => {
      if (res.status == 'success') {
        this.transactionhistory = res.data
      }
    })

    let session_id = this.route.snapshot.queryParamMap.get('session_id')
    if (session_id) {
      window.history.replaceState( {} , '', window.location.origin + window.location.pathname );
      let data = {
        sessionid: session_id
      }
      this.transactionservice.verifypaymentstatus(data).subscribe((res: any) => {
        this.fetchplandetails()
        if (res.stripesubscriptionid) {
          this._localstorageservice.setItem('stripesubscriptionid', res.stripesubscriptionid)
          this.stripesubscriptionid = res.stripesubscriptionid
        }
        if (res.status == 'success' || res.message == 'Subscription has already started, credits unchanged') {
          this.successMessage = 'Plan Updated Successfully';
          setTimeout(() => this.successMessage = '', 5000);
        } else {
          this.errorMessage = 'Transaction was not completed';
          setTimeout(() => this.errorMessage = '', 5000);
        }
      })
    }

    this.teamservice.fetchteaminvitelink().subscribe((res: any) => {
      if (res.status == 'success') {
        this.invitelink = res.inviteurl
      }
    })

    this.getallTeam(0)
    this.fetchplandetails()

  }
  fetchplandetails() {
    this.transactionservice.fetchcurrentplandetails(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == 'success') {
        this.unlimitedbasiccontactcredits = res.data.unlimitedbasiccontactcredits
        this.subscriptiondetails = res.data
        this.isuseronpaidplan = res.data.isuseronpaidplan
        this.showteamtab = res.data.showteamtab
        this.isteammember = res.data.isteammember
        this.isteamMember = null
        this._localstorageservice.setItem('paymentplanname',this.subscriptiondetails.paymentplanname)
        this._localstorageservice.setItem('plantype',this.subscriptiondetails.plantype)
        this._localstorageservice.setItem('isteamMember',null)
        if (res.data.isteamadmin) {
          // Here the logged in person is a Team Admin
          this.userisadmin = true
          this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
          this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
          this.subscriptiondetails.balancejdparsingcredits = res.data.pooledbalancejdparsingcredits;
          this.subscriptiondetails.balancesmartemailcredits = res.data.pooledbalancesmartemailcredits;
          this.subscriptiondetails.balancetalentpipelinecredits = res.data.pooledbalancetalentpipelinecredits;
          this.subscriptiondetails.balancebulkgrabbingcredits = res.data.pooledbalancebulkgrabbingcredits;
          this.subscriptiondetails.cepercentage = ((this.subscriptiondetails.balancecontactenrichmentcredits / this.subscriptiondetails.contactenrichmentcredits) * 100).toFixed(2)
        } else {
          this.userisadmin = false
          if (res.data.teamadmindetails) {
            // Here the logged in person is a Team Member
            this.teamAdminDetails = res.data.teamadmindetails
            this.isteamMember = true
            this._localstorageservice.setItem('isteamMember',this.isteamMember)
            this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.teamadmindetails.adminbalancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.teamadmindetails.adminbalancesmartemailcredits;
            this.subscriptiondetails.balancebulkgrabbingcredits = res.data.teamadmindetails.adminbalancebulkgrabbingcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.teamadmindetails.adminbalancetalentpipelinecredits;
            this.subscriptiondetails.cepercentage = ((this.subscriptiondetails.balancecontactenrichmentcredits / this.subscriptiondetails.reservedcontactcreditscount) * 100).toFixed(2)
            this.subscriptiondetails.bcepercentage = ((this.subscriptiondetails.balancebasiccontactenrichmentcredits / this.subscriptiondetails.reservedbasiccontactcreditscount) * 100).toFixed(2)
            this.subscriptiondetails.contactenrichmentcredits = this.subscriptiondetails.reservedcontactcreditscount
            this.subscriptiondetails.basiccontactenrichmentcredits = this.subscriptiondetails.reservedbasiccontactcreditscount
          } else {
            // Here the logged in person is a normal (who does not belong to any team)
            this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.balancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.balancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.balancetalentpipelinecredits;
            this.subscriptiondetails.balancebulkgrabbingcredits = res.data.balancebulkgrabbingcredits;
            this.subscriptiondetails.cepercentage = ((this.subscriptiondetails.balancecontactenrichmentcredits / this.subscriptiondetails.contactenrichmentcredits) * 100).toFixed(2)
            this.subscriptiondetails.bcepercentage = ((this.subscriptiondetails.balancebasiccontactenrichmentcredits / this.subscriptiondetails.basiccontactenrichmentcredits) * 100).toFixed(2)
          }
        }
        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('grabcredits', this.subscriptiondetails.balancebulkgrabbingcredits)
        this.subscriptiondetails.jdpercentage = ((this.subscriptiondetails.balancejdparsingcredits / this.subscriptiondetails.jdparsingcredits) * 100).toFixed(2)
        this.subscriptiondetails.sepercentage = ((this.subscriptiondetails.balancesmartemailcredits / this.subscriptiondetails.smartemailcredits) * 100).toFixed(2)
        this.subscriptiondetails.grabpercentage = ((this.subscriptiondetails.balancebulkgrabbingcredits / this.subscriptiondetails.bulkgrabbingcredits) * 100).toFixed(2)
        this.subscriptiondetails.tppercentage = ((this.subscriptiondetails.balancetalentpipelinecredits / this.subscriptiondetails.talentpipelinecredits) * 100).toFixed(2)
        this.subscriptiondetails.overallpercentage = ((res.data.totalbalancecreditswithentireteam / this.subscriptiondetails.contactenrichmentcredits) * 100).toFixed(2)
        this.subscriptiondetails.overallbasicpercentage = ((res.data.totalbalancebasiccreditswithentireteam / this.subscriptiondetails.basiccontactenrichmentcredits) * 100).toFixed(2) //here updated
        this.subscriptiondetails.overallcredits = res.data.totalbalancecreditswithentireteam
        this.subscriptiondetails.overallbasiccredits = res.data.totalbalancebasiccreditswithentireteam
        this.adminDetails.cepercentage = ((this.adminDetails?.usedcontactcreditscount / this.adminDetails?.reservedcontactcreditscount) * 100).toFixed(2)
        this.adminDetails.bcepercentage = ((this.adminDetails?.usedbasiccontactcreditscount / this.adminDetails?.reservedbasiccontactcreditscount) * 100).toFixed(2)
        if (this.unlimitedbasiccontactcredits) {
          this.adminbasiccredits = 'Unlimited'
          this.subscriptiondetails.bcepercentage = 100
        }

        // update in localstorage
        const userData = this._localstorageservice.getItem('userdata');
        userData['balancebasiccontactenrichmentcredits'] = this.subscriptiondetails.balancebasiccontactenrichmentcredits;
        this._localstorageservice.setItem('userdata', userData);

        // notify header to render latest data
        this.transactionservice.createPaymentData();
      }
    })
  }

  getallTeam(index) {
    this.teamservice.fetchallteaminvites(index).subscribe((res: any) => {
      if (res.status == 'success') {
        this.teamlist = res.teaminvitesarray
        this.adminDetails = res.teamAdminDetails
        this.admincredits = this.adminDetails.reservedcontactcreditscount
        this.adminbasiccredits = this.adminDetails.reservedbasiccontactcreditscount
        this.total = res.totalcount
        if (this.start == 0) {
          if (this.end > this.total) {
            this.end = this.total
          }
          if (this.total == 0) {
            this.start = this.total;
            this.end = this.total
          } else if (this.total < 50) {
            this.end = this.total
          } else {
            this.end = this.start + 50;
          }
        }
      }
    })
  }

  pagination(type) {
    if (type == 'next') {
      this.tstart = this.tstart + 50
      this.end = this.tstart + 50
      if (this.end > this.total)
        this.end = this.total
      this.getallTeam(this.tstart);
    } else if (type == 'prev') {
      this.start = this.start - 50
      this.end = this.start + 50
      this.getallTeam(this.tstart);
    }
  }

  route2page(type) {
    if (type == 'history') {
      // this.router.navigateByUrl('subscription/history')
      window.history.replaceState({}, '', `/subscription/history`);
      this.history = true
    }

    if (type == 'usage') {
      // this.router.navigateByUrl('subscription/usage')
      window.history.replaceState({}, '', `/subscription/usage`);
      this.history = false
    }

    if (type == 'plan') {
      if (this.isteamMember) {
        this.modalService.open(this.requestCredit, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      } else {
        this.router.navigateByUrl('subscription/pricing')
      }
    }
  }

  invitemembermodal(data?) {
    if (data) {
      this.selectedteams.push(data)
      this.inputemails = data.inviteeemailid
      this.credits = data.contactenrichmentusagelimit
      this.basiccredits = data.basiccontactenrichmentusagelimit
    }
    if (this.teamlist.length == 0) {
      this.modalService.open(this.reservecredits, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    } else {
      this.modalService.open(this.invitemember, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    }
  }

  dismiss() {
    this.modalService.dismissAll()
    this.selectedteams = []
    this.inviteemails = []
    this.selectAll(false)
    this.inputemails = ''
    this.emailError = false
    this.credits = null
    this.basiccredits = null
    this.noAdminCredits = false
    this.duplicateEmail = false
    this.adminEmailidUsed = false
  }

  addemails() {
    let regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/g
    if (this.inputemails && this.inputemails.trim() != '') {
      if (this.inputemails != this.adminDetails.loginemail) {
        this.adminEmailidUsed = false
        let enteredEmail;
        if (regexEmail.test(this.inputemails) == true) {
          this.inviteemails.push(this.inputemails)
          this.inviteemails = _.uniq(this.inviteemails)
          enteredEmail = this.inputemails
          this.inputemails = ''
          this.emailError = false
        }
        let duplicateemail = this.teamlist.filter((x: any) => {
          return x.inviteeemailid.trim() == enteredEmail
        })
        if (duplicateemail && duplicateemail.length > 0) {
          this.duplicateEmail = true
        }
      } else {
        this.adminEmailidUsed = true
      }
    } else {
      this.emailError = true
    }
  }

  removeemails(email) {
    this.inviteemails = this.inviteemails.filter(x => x != email)
  }

  invitemembers() {
    if (this.inputemails && this.inputemails.trim() != '') {
      this.addemails()
    }
    if (!this.emailError && !this.duplicateEmail && !this.adminEmailidUsed) {
      if (this.inviteemails && this.inviteemails.length > 0) {
        let data = {}
        let userdetailsarray = []
        this.inviteemails.forEach(element => {
          userdetailsarray.push({
            "emailid": element,
            "contactenrichmentusagelimit": this.credits ? this.credits : null,
            "basiccontactenrichmentusagelimit": this.unlimitedbasiccontactcredits ? "-1" : this.basiccredits
          })
        });

        data['userdetailsarray'] = userdetailsarray
        this.teamservice.sendteaminviteviaemail(data).subscribe((res: any) => {
          if (res.status == 'success') {
            this.noAdminCredits = false
            this.dismiss()
            this.getallTeam(0)
            this.fetchplandetails()
            this.inviteemails = []
            this.successMessage = 'Team invite send successfully';
            setTimeout(() => this.successMessage = '', 5000);
          } else if (res.err == 'Usage limit exceeded') {
            this.noAdminCredits = true
          }
        })
      } else {
        this.emailLengthError = true
      }

    }
  }

  selectAll(value) {
    if (value == true) {
      this.selectedteams = []
      this.teamlist.forEach((element, index) => {
        this.teamlist[index].selected = true;
        this.selectedteams.push(element)
      })
      this.isBulkSelect = true
    } else if (value == false) {
      this.teamlist.forEach((element, index) => {
        this.teamlist[index].selected = false;
        this.selectedteams = []
      })
      this.isBulkSelect = false;
      this.selected = false;
    }
  }

  checkIfAllSelected(element, value) {
    if (value == true) {
      this.selectedteams.push(element)
      this.selectedteams = _.uniq(this.selectedteams, 'inviteeemailid')
    } else {
      this.selectedteams = this.selectedteams.filter(x => { return x.inviteeemailid != element.inviteeemailid })
    }
  }

  changebulkcreditsforteam() {
    if (this.selectedteams && this.selectedteams.length > 1) {
      this.inputemails = this.selectedteams.length + ' selected'
    } else {
      this.inputemails = this.selectedteams[0].inviteeemailid
    }
    this.modalService.open(this.invitemember, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  savebulkcredits() {
    let data = {
      memberemailidsarray: this.selectedteams.map(x => { return x.inviteeemailid }),
      contactcreditscount: this.credits ? this.credits : null,
      basiccontactcreditscount: this.unlimitedbasiccontactcredits ? "-1" : this.basiccredits
    }
    this.noAdminCredits = false
    this.teamservice.updatecontactenrichmentcredits(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.dismiss()
        this.getallTeam(0)
        this.fetchplandetails()
        this.successMessage = 'Team credits updated succesfully';
        setTimeout(() => this.successMessage = '', 5000);
        this.isBulkSelect = false;
        this.selected = false;
      } else if (res.err == 'Usage limit exceeded') {
        this.noAdminCredits = true
      }
    })
  }

  copyinvitelink() {
    var inp = document.createElement('input');
    document.body.appendChild(inp)
    inp.value = this.invitelink
    inp.select();
    document.execCommand('copy', false);
    inp.remove();
    this.successMessage = 'Link copied succesfully';
    setTimeout(() => this.successMessage = '', 5000);
  }

  removemembermodal(data) {
    if (data) {
      this.removedmemberArray.push(data)
    }
    this.modalService.open(this.removeteam, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }


  resendlinkmodal(data) {
    if (data) {
      this.resendteamArray = [data]
    }
    this.modalService.open(this.resendlink, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  RemoveTeam() {
    let data = {
      teaminviteidsarray: [this.removedmemberArray[0].teaminviteid]
    }

    this.teamservice.removemember(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.dismiss()
        this.getallTeam(0)
        this.fetchplandetails()
        this.successMessage = this.removedmemberArray[0].inviteeemailid + 'removed from group succesfully';
        this.removedmemberArray = []
        setTimeout(() => this.successMessage = '', 5000);
      }
    })
  }

  resendLink() {
    let data = {}
    let userdetailsarray = []
    this.resendteamArray.forEach(element => {
      userdetailsarray.push({
        "emailid": element.inviteeemailid,
        "contactenrichmentusagelimit": element.contactenrichmentusagelimit,
        "basiccontactenrichmentusagelimit": element.basiccontactenrichmentusagelimit,
        "teaminviteid": element.teaminviteid
      })
    });

    data['userdetailsarray'] = userdetailsarray
    this.teamservice.sendteaminviteviaemail(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.dismiss()
        this.successMessage = 'Invitation link has been resend to ' + ''
        setTimeout(() => this.successMessage = '', 5000);
      }
    })
  }

  editAdminCredits() {
    this.modalService.open(this.reservecredits, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  reservecreditsAdmin() {
    if (this.admincredits != undefined) {
      let data = {
        numberofcontactcredits: this.admincredits,
        numberofbasiccontactcredits: this.unlimitedbasiccontactcredits ? "-1" : this.adminbasiccredits
      }
      this.teamservice.reserveadmincredits(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.dismiss()
          this.admincreditsError = ''
          this.successMessage = 'Credits reserved succesfully';
          setTimeout(() => this.successMessage = '', 5000);
          this.noAdminCredits = false
          this.modalService.dismissAll()
          this.getallTeam(0)
          this.fetchplandetails()
          if (this.teamlist.length == 0 && this.admincredits >= 0) {
            this.modalService.open(this.invitemember, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
          }
        } else if (res.err == 'Usage limit exceeded') {
          this.noAdminCredits = true
        }
      })
    } else {
      this.admincreditsError = 'Credits are required'
    }
  }

  leaveteammodal() {
    this.modalService.open(this.leaveteam, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  submitleaveteam() {
    this.teamservice.leaveteamlink().subscribe((res: any) => {
      if (res.status == 'success') {
        this.successMessage = 'Team left succesfully';
        setTimeout(() => this.successMessage = '', 5000);
        this.fetchplandetails()
        this.modalService.dismissAll()
      }
    })
  }

  noDecimals(e) {
    return !(e.charCode == 46)
  }

  cancelsubs(type?) {
    if (type) {
      this.modalService.open(this.cancelSubscription, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    } else {
      let data = {
        subscriptionid: this.stripesubscriptionid
      }
      this.transactionservice.cancelsubscription(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.fetchplandetails()
          this.modalService.dismissAll()
          this.successMessage = 'Subscription cancelled successfully';
          this._localstorageservice.setItem('stripesubscriptionid', null)
          this.stripesubscriptionid = null
          setTimeout(() => this.successMessage = '', 5000);
        } else {
          this.errorMessage = 'Something went wrong';
          setTimeout(() => this.errorMessage = '', 5000);
        }
      })
    }
  }
}
